import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const MODELS = [
  { label: 'Gemini Flash (fast & cheap)', value: 'google/gemini-flash-1.5' },
  { label: 'Claude Haiku (smart & cheap)', value: 'anthropic/claude-haiku-20240307' },
  { label: 'Mistral 7B (lightweight)', value: 'mistralai/mistral-7b-instruct' },
  { label: 'Claude Sonnet (admin only)', value: 'anthropic/claude-3.5-sonnet' },
  { label: 'GPT-4o (admin only)', value: 'openai/gpt-4o' },
];

function CreateCompanion() {
  const [name, setName] = useState('');
  const [chatPrompt, setChatPrompt] = useState('');
  const [roleplayPrompt, setRoleplayPrompt] = useState('');
  const [voiceId, setVoiceId] = useState('');
  const [model, setModel] = useState('google/gemini-flash-1.5');
  const [isPublished, setIsPublished] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const handleCreate = async () => {
    if (!name || !chatPrompt) {
      setError('name and chat prompt are required 🥀');
      return;
    }
    try {
      await axios.post(`${API}/companions`, {
        token,
        name,
        chat_prompt: chatPrompt,
        roleplay_prompt: roleplayPrompt || chatPrompt,
        voice_id: voiceId || 'placeholder',
        model,
        is_published: isPublished
      });
      navigate('/companions');
    } catch {
      setError('something went wrong 🥀');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate('/companions')}>←</button>
        <div style={styles.title}>new companion</div>
        <div style={{ width: '36px' }} />
      </div>

      <div style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>name</label>
          <input
            style={styles.input}
            placeholder="Caleb"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>chat prompt</label>
          <textarea
            style={styles.textarea}
            placeholder="You are Caleb, warm and caring..."
            value={chatPrompt}
            onChange={e => setChatPrompt(e.target.value)}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>roleplay prompt</label>
          <textarea
            style={styles.textarea}
            placeholder="You are Caleb, write descriptively with actions like *he smiles*..."
            value={roleplayPrompt}
            onChange={e => setRoleplayPrompt(e.target.value)}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>elevenlabs voice ID</label>
          <input
            style={styles.input}
            placeholder="paste your elevenlabs voice ID here"
            value={voiceId}
            onChange={e => setVoiceId(e.target.value)}
          />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>AI model</label>
          <select
            style={styles.select}
            value={model}
            onChange={e => setModel(e.target.value)}
          >
            {MODELS.map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>

        <div style={styles.toggleRow}>
          <label style={styles.label}>published (visible to friends)</label>
          <button
            style={{...styles.toggle, ...(isPublished ? styles.toggleOn : {})}}
            onClick={() => setIsPublished(!isPublished)}
          >
            {isPublished ? 'yes' : 'no'}
          </button>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.createBtn} onClick={handleCreate}>
          create companion ♡
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0e0b0f',
    fontFamily: 'Georgia, serif',
    maxWidth: '480px',
    margin: '0 auto',
  },
  header: {
    padding: '20px 20px 16px',
    background: 'linear-gradient(180deg, #120f18 0%, #0e0b0f 100%)',
    borderBottom: '1px solid rgba(201,147,90,0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backBtn: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: '1px solid rgba(201,147,90,0.15)',
    background: 'transparent',
    color: '#c9935a',
    fontSize: '16px',
    cursor: 'pointer',
  },
  title: {
    fontSize: '20px',
    color: '#e8ddd0',
    fontWeight: '300',
    fontStyle: 'italic',
  },
  form: {
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '10px',
    color: '#7a6a5a',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  input: {
    padding: '14px 18px',
    borderRadius: '16px',
    border: '1.5px solid rgba(201,147,90,0.15)',
    background: '#1a1520',
    color: '#e8ddd0',
    fontSize: '14px',
    fontFamily: 'Georgia, serif',
    outline: 'none',
  },
  textarea: {
    padding: '14px 18px',
    borderRadius: '16px',
    border: '1.5px solid rgba(201,147,90,0.15)',
    background: '#1a1520',
    color: '#e8ddd0',
    fontSize: '13px',
    fontFamily: 'Georgia, serif',
    outline: 'none',
    minHeight: '120px',
    resize: 'none',
    lineHeight: '1.6',
  },
  select: {
    padding: '14px 18px',
    borderRadius: '16px',
    border: '1.5px solid rgba(201,147,90,0.15)',
    background: '#1a1520',
    color: '#e8ddd0',
    fontSize: '14px',
    fontFamily: 'Georgia, serif',
    outline: 'none',
  },
  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toggle: {
    padding: '8px 20px',
    borderRadius: '20px',
    border: '1.5px solid rgba(201,147,90,0.2)',
    background: 'transparent',
    color: '#7a6a5a',
    fontSize: '13px',
    cursor: 'pointer',
    fontFamily: 'Georgia, serif',
  },
  toggleOn: {
    background: 'rgba(201,147,90,0.1)',
    border: '1.5px solid rgba(201,147,90,0.4)',
    color: '#c9935a',
  },
  createBtn: {
    width: '100%',
    padding: '15px',
    borderRadius: '16px',
    border: 'none',
    background: 'linear-gradient(135deg, #8a5f35, #c9935a)',
    color: '#0e0b0f',
    fontSize: '14px',
    fontFamily: 'Georgia, serif',
    cursor: 'pointer',
    boxShadow: '0 8px 20px rgba(201,147,90,0.3)',
    marginTop: '8px',
  },
  error: {
    color: '#c9935a',
    fontSize: '13px',
    textAlign: 'center',
  }
};

export default CreateCompanion;
